module.exports = __webpack_public_path__ + "static/media/GG_Logo.a68ac1fb.svg";